import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';

library.add(faAngleRight);

export class Caret extends Component {
    render() {
        let className = 'area-caret';
        if (!this.props.open) {
            className += ' caret-open';
        }

        return <FontAwesomeIcon icon='angle-right' className={className} />;
    }
}
